import React, { useState } from "react";
import "./HomePageCss/TestimonialSection.css";
import TestimonialCarousel, { users } from "./TestimonialCarousal";

// import myvideo from "../../Assets/Rb_video.MP4";
import { submitFeedback } from "../../api/api";
import toast from "react-hot-toast";

export default function TestimonialSection() {
  const [activeTestimonial, setActiveTestimonial] = useState(users[0]);
  const [showModal, setShowModal] = useState(false);
  const [feedbackData, setFeedbackData] = useState({
    username: "",
    mobile: "",
    feedback: "",
    rating: 5,
  });

  const getTrimmedComment = (comment) => {
    return comment.length > 30 ? comment.slice(0, 150) + "..." : comment;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedbackData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",

        mobile_no: feedbackData.mobile,
        rate: feedbackData.rating,
        comment: `${feedbackData.username} :${feedbackData.feedback}`,
      };
      const response = await submitFeedback(payload);
      console.log("Feedback submission response:", response);
      setShowModal(false);
      setFeedbackData({ username: "", mobile: "", feedback: "" });
      toast.success("Feedback submitted successfully!");
    } catch (err) {
      console.error("Error submitting feedback:", err);
    }
  };

  return (
    <div className="testimonialContainer">
      <h2 className="rb-title testimonial-title">Client Testimonial</h2>

      <div className="testimonialMiddleSection">
        <TestimonialCarousel onSlideChange={setActiveTestimonial} />
      </div>

      <div className="testimonialLowerSection">
        <div className="videoSection">
          <video controls className="responsiveVideo">
            <source
              src="https://d3c5rx7t9wpvpx.cloudfront.net/screen_videos/Review-video.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div className="testimonialTextSection">
          <div className="testimonialTextCircleDiv" />
          <p style={{ margin: "0", fontStyle: "italic", color: "#333" }}>
            "{getTrimmedComment(activeTestimonial.comments)}"
          </p>
          <p style={{ marginTop: "0.5rem", fontWeight: "bold" }}>
            - {activeTestimonial.name}
          </p>
        </div>

        <div className="testimonianlButton">
          <div className="buttonWrapper">
            <button
              className="feedbackbtn rbdButton"
              onClick={() => setShowModal(true)}
            >
              <span className="btn-text">Give Feedback</span>
            </button>
          </div>
        </div>
      </div>

      {/* Feedback Modal */}
      {showModal && (
        <div className="feedback-modal-overlay">
          <div className="feedback-modal-content">
            <span
              className="close-btn-feedback"
              onClick={() => setShowModal(false)}
            >
              &times;
            </span>
            <h3>Give Your Feedback</h3>
            <form onSubmit={handleSubmit} className="feedback-form">
              <label>
                Name:
                <input
                  type="text"
                  name="username"
                  value={feedbackData.username}
                  onChange={handleChange}
                  required
                />
              </label>
              <label>
                Mobile:
                <input
                  type="tel"
                  name="email"
                  value={feedbackData.email}
                  onChange={handleChange}
                  required
                />
              </label>
              <label className="rating-label">
                Rating:
                <div className="rating-stars">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      className={`stars ${
                        star <= feedbackData.rating ? "filled" : ""
                      }`}
                      onClick={() =>
                        setFeedbackData((prev) => ({ ...prev, rating: star }))
                      }
                    >
                      ★
                    </span>
                  ))}
                </div>
              </label>

              <label>
                Comment:
                <textarea
                  name="feedback"
                  rows="4"
                  value={feedbackData.feedback}
                  onChange={handleChange}
                  required
                />
              </label>
              <button type="submit" className="rbdButton">
                {" "}
                <span className="btn-text">Submit</span>
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
